@if (showSkip) {
  <div class="question-skip">
    <label class="custom-toggle custom-toggle--md custom-toggle--inline custom-toggle--transparent">
      <input
        type="checkbox"
        [checked]="skipped"
        [(ngModel)]="skipped"
        (ngModelChange)="onSkipChange()"
        name="add-note-toggle"
        id="skip-driver-details-toggle">
        <span class="custom-toggle__indi"></span>
        <span class="custom-toggle__label">Skip for now</span>
      </label>
    </div>
  }
  @if (!displayInline) {
    <label class="custom-toggle">
      <input type="checkbox" (click)="checkToggle($event)" [name]="uniqueControlName" [id]="uniqueControlId"
        [checked]="question?.answer === 'true'">
        <span class="custom-toggle__indi"></span>
        <span class="custom-toggle__label">{{toggleLabel}}</span>
      </label>
    }

    @if (displayInline) {
      <label class="custom-toggle custom-toggle--inline"
       [ngClass]="{
           'custom-toggle--sm': displayInlineSize === toggleSize.Small,
           'custom-toggle--md': displayInlineSize === toggleSize.Medium,
           'custom-toggle--lg': displayInlineSize === toggleSize.Large
           }">
        <input type="checkbox" (click)="checkToggle($event)" [name]="uniqueControlName" [id]="uniqueControlId"
          [checked]="question?.answer === 'true'">
          <span class="custom-toggle__indi"></span>
          <span class="custom-toggle__label">{{toggleLabel}}</span>
        </label>
      }
